import React, { createContext, useContext, useState, useEffect } from "react";

interface Vendor {
  company_address: string;
  company_email: string;
  company_name: string;
  state: string;
  country: string;
  pincode: string;
  company_phone: string;
  company_landline: string;
}

type VendorContextType = {
  vendor: Vendor | null;
  setVendor: (data: Vendor) => void;
};

const VendorContext = createContext<VendorContextType | undefined>(undefined);

export const VendorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [vendor, setVendorState] = useState<Vendor | null>(null);

  useEffect(() => {
    const stored = localStorage.getItem("selected_vendor");
    if (stored) setVendorState(JSON.parse(stored));
  }, []);

  const setVendor = (data: Vendor) => {
    localStorage.setItem("selected_vendor", JSON.stringify(data));
    setVendorState(data);
  };

  return (
    <VendorContext.Provider value={{ vendor, setVendor }}>
      {children}
    </VendorContext.Provider>
  );
};

export const useVendor = () => {
  const ctx = useContext(VendorContext);
  if (!ctx) throw new Error("useVendor must be used inside VendorProvider");
  return ctx;
};
